import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchMember } from '../actions/members';
import Navigation from './shared/navigation';
import Spinner from './shared/spinner';
import Body from './shared/body'
import Alert from "./alert";
import CacheService from '../services/cacheService';

class App extends Component {

    componentDidMount() {
        this.props.fetchMember(this.props.history);
    }

    render () {
        const { member } = this.props;
        if (!member) {
            return ( <div> <Spinner /> </div> );
        } else {
            return (
                <div>
                    <Navigation member={member} bname={CacheService.getToken().bname}/>
                    <Alert />
                    <Body {...this.props} />
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    const { member } = state;
    return {
        member
    };
}

export default connect(mapStateToProps, { fetchMember })(App);



// WEBPACK FOOTER //
// ./src/components/app.js